import React, { useContext, useState } from 'react'
import AddShiftPopup from '../AddShiftPopup'
import { TenantSettingsContext } from '../../../../../App'
import { formatMoney } from '../../../../../helpers/currency'
import {
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Slider,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

const Personnel = ({
  setAddShift,
  personnel,
  setPersonnel,
  addShift,
  profitMargin,
}) => {
  const { orgSettings } = useContext(TenantSettingsContext).orgConfig
  const [selectedShift, setSelectedShift] = useState(null)
  return (
    <Box>
      <Table>
        <TableHead>
          <TableRow sx={{ fontWeight: 'bold' }}>
            <TableCell sx={{ fontWeight: 'bold' }}>Role</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Rate Type</TableCell>
            <TableCell align="right" sx={{ fontWeight: 'bold' }}>
              Rate
            </TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {personnel.map((shift, index) => (
            <TableRow key={index} sx={{ cursor: 'pointer' }}>
              <TableCell>{shift.grade}</TableCell>
              <TableCell>{shift.isHourly ? 'Hourly' : 'Fixed'}</TableCell>
              <TableCell align="right">
                {formatMoney(
                  shift.rate + (shift.rate * profitMargin) / 100,
                  orgSettings?.currency,
                )}
              </TableCell>
              <TableCell>
                <Stack direction="row" justifyContent="flex-end">
                  <IconButton
                    onClick={() => setSelectedShift({ shift, index })}
                    size="small"
                  >
                    <EditIcon fontSize="small" color="anBlue" />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => {
                      setPersonnel((prev) => [...prev, { ...shift }])
                    }}
                  >
                    <ContentCopyIcon fontSize="small" color="anGreen" />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => {
                      setPersonnel((prev) => prev.filter((x, i) => index !== i))
                    }}
                  >
                    <DeleteIcon fontSize="small" color="error" />
                  </IconButton>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <AddShiftPopup
        selectedShift={selectedShift}
        setAddShift={setAddShift}
        setPersonnel={setPersonnel}
        addShift={addShift}
        open={!!addShift || !!selectedShift}
        onClose={() => {
          setAddShift(false)
          setSelectedShift(null)
        }}
      />
    </Box>
  )
}

export default Personnel
